var render = function () {
  var _vm$branchStats, _vm$branchStats2, _vm$modalChoosedBranc;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("控制中心")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("分店管理")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("分店管理")])]), _c('div', {
    staticClass: "col-12 col-xl-4"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋分店編號或店名"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageReset.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.query,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "query", $$v);
      },
      expression: "query.query"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('div', {
    staticClass: "d-flex flex-column flex-xl-row mt-4 mb-3 justify-content-between"
  }, [_c('b-breadcrumb', {
    staticClass: "mb-2 p-0",
    attrs: {
      "items": _vm.breadcrumb
    }
  }), _c('div', [_vm.$permissions.has(_vm.$permissions.consts.BRANCH_LIST_VIEW) ? _c('b-dropdown', {
    staticClass: "flex-shrink-0 mb-2 ml-2",
    attrs: {
      "variant": "inverse-info"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('span', {
          staticClass: "mdi mdi-download"
        }), _vm._v(" 資料匯出 ")];
      },
      proxy: true
    }], null, false, 3637287782)
  }, [_c('b-dropdown-item', {
    on: {
      "click": _vm.exportBranches
    }
  }, [_vm._v("分店資料匯出")]), _vm.$permissions.has(_vm.$permissions.consts.BRANCH_REGISTER_URL_EXPORT) ? _c('b-dropdown-item', {
    on: {
      "click": _vm.exportBranchesQrCodes
    }
  }, [_vm._v("分店註冊QRCode圖片匯出")]) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.BRANCH_TO_OA_URL_EXPORT) ? _c('b-dropdown-item', {
    on: {
      "click": _vm.exportBranchesOaQrCodes
    }
  }, [_vm._v("分店轉導OA QRCode圖片匯出")]) : _vm._e()], 1) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.BRANCH_IMPORT_TW_CITY) && _vm.$route.name !== 'Branches' && _vm.activeBranch && _vm.activeBranch.level < 6 && !_vm.$route.query.query ? _c('b-button', {
    staticClass: "ml-4",
    attrs: {
      "variant": "primary",
      "disabled": _vm.activeBranch && _vm.activeBranch.branch_type === 'shop'
    },
    on: {
      "click": _vm.generateTwBranch
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 匯入台灣縣市 ")]) : _vm._e(), _vm.showCreateButton && !_vm.$route.query.query && !this.branchID ? _c('b-button', {
    staticClass: "ml-4",
    attrs: {
      "variant": "primary",
      "disabled": _vm.activeBranch && _vm.activeBranch.branch_type === 'shop'
    },
    on: {
      "click": function click($event) {
        return _vm.handleUpload(true);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("上傳最上層分店 ")]) : _vm._e(), _vm.showUploadButton ? _c('b-button', {
    staticClass: "ml-4",
    attrs: {
      "variant": "primary",
      "disabled": _vm.activeBranch && _vm.activeBranch.branch_type === 'shop'
    },
    on: {
      "click": function click($event) {
        return _vm.handleUpload(false);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("上傳分店 ")]) : _vm._e(), _vm.showCreateButton && !_vm.$route.query.query ? _c('b-button', {
    staticClass: "ml-4",
    attrs: {
      "variant": "primary",
      "disabled": _vm.activeBranch && _vm.activeBranch.branch_type === 'shop'
    },
    on: {
      "click": _vm.handleCreate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.$route.name === "Branches" ? "新增最上層分店" : "新增分店") + " ")]) : _vm._e()], 1)], 1), _vm.activeBranch && _vm.activeBranch.branch_type === 'area' || !_vm.branchID ? _c('div', {
    staticClass: "mb-3 p-2"
  }, [_c('span', [_vm._v("分區數目：" + _vm._s(((_vm$branchStats = _vm.branchStats) === null || _vm$branchStats === void 0 ? void 0 : _vm$branchStats.area_count) || 0))]), _c('br'), _c('span', [_vm._v("門市數目：" + _vm._s(((_vm$branchStats2 = _vm.branchStats) === null || _vm$branchStats2 === void 0 ? void 0 : _vm$branchStats2.shop_count) || 0))])]) : _vm._e(), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.branches,
      "fields": _vm.fields,
      "busy": _vm.isLoading
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(branch_code)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'BranchesShow',
              params: {
                branchID: data.item.id
              }
            }
          }
        }, [_vm._v(_vm._s(data.item.branch_code))])];
      }
    }, {
      key: "cell(is_enabled)",
      fn: function fn(data) {
        return [_c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "variant": !!data.item.is_enabled === true ? 'success' : 'secondary'
          }
        }, [_vm._v(_vm._s(!!data.item.is_enabled === true ? "啟用" : "停用"))])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-dropdown', {
          staticClass: "ml-2",
          attrs: {
            "variant": "secondary"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "mdi mdi-menu"
        })]), _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'BranchUpdateImage',
              params: {
                branchID: data.item.id
              }
            }
          }
        }, [_vm._v(" 設定圖片 ")]), _vm.$permissions.has(_vm.$permissions.consts.BRANCH_CONFIG_MENU) ? _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'BranchMenuEditor',
              params: {
                branchID: data.item.id
              }
            }
          }
        }, [_vm._v(" 分店選單 ")]) : _vm._e(), _vm.$permissions.hasAny([_vm.$permissions.consts.BRANCH_DETAIL_VIEW_STAFF, _vm.$permissions.consts.BRANCH_DETAIL_DELETE_STAFF, _vm.$permissions.consts.BRANCH_DETAIL_CHANGE_PASSWORD]) ? _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'BranchStaffs',
              params: {
                branchID: data.item.id
              }
            }
          }
        }, [_vm._v(" 店內帳號 ")]) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.BRANCH_CONFIG_SERVICE) ? _c('b-dropdown-item', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal",
            value: 'modal-branch-settings',
            expression: "'modal-branch-settings'"
          }],
          on: {
            "click": function click($event) {
              _vm.modalChoosedBranch = data.item;
            }
          }
        }, [_vm._v(" 分店服務設定 ")]) : _vm._e(), _vm.showDisableButton ? _c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.handleUpdateEnabled(data.item.id, data.item, !data.item.is_enabled);
            }
          }
        }, [_vm._v(" " + _vm._s(data.item.is_enabled ? "停用分店" : "啟用分店") + " ")]) : _vm._e()], 2), !_vm.activeBranch || _vm.activeBranch && _vm.activeBranch.level < 6 ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-info",
            "to": {
              name: 'BranchesSubLayer',
              params: {
                branchID: data.item.id
              }
            },
            "disabled": _vm.activeBranch && _vm.activeBranch.branch_type === 'shop' || data.item.branch_type === 'shop'
          }
        }, [_c('span', {
          staticClass: "mdi mdi-sitemap mr-1"
        }), _vm._v("下層 ")]) : _vm._e(), _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "to": {
              name: 'BranchesShow',
              params: {
                branchID: data.item.id
              }
            },
            "variant": "inverse-primary"
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye mr-1"
        }), _vm._v("查看 ")]), _vm.showModifyButton ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'BranchesEdit',
              params: {
                branchID: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil mr-1"
        }), _vm._v("編輯 ")]) : _vm._e(), _vm.showDeleteButton ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.handleDelete(data.item.id, data.item.branch_code, data.item.name);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete mr-1"
        }), _vm._v("刪除 ")]) : _vm._e()];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.total,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-branch-settings",
      "title": (_vm$modalChoosedBranc = _vm.modalChoosedBranch) === null || _vm$modalChoosedBranc === void 0 ? void 0 : _vm$modalChoosedBranc.name,
      "centered": ""
    },
    on: {
      "hidden": function hidden($event) {
        _vm.modalChoosedBranch = null;
      },
      "ok": _vm.handleBranchConfigSave
    }
  }, [_c('b-form-checkbox-group', {
    staticClass: "mb-3",
    attrs: {
      "name": "services"
    },
    model: {
      value: _vm.safeBranchConfigService,
      callback: function callback($$v) {
        _vm.safeBranchConfigService = $$v;
      },
      expression: "safeBranchConfigService"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": "nearby"
    }
  }, [_vm._v("鄰近分店")]), _c('b-form-checkbox', {
    attrs: {
      "value": "booking"
    }
  }, [_vm._v("預約")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }